import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { RequestWrapper } from "../../routers/request-wrapper";
import { References, CreateReference, Reference } from "./pages";

export const AdminReferencesRouter = [
  <Route
    path="/references"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={References} />
      </ProtectedRoute>
    }
  />,
  <Route
    path="/references/create"
    element={
      <ProtectedRoute roles={["Any"]}>
        <CreateReference />
      </ProtectedRoute>
    }
  />,
  <Route path="/reference">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Reference />
        </ProtectedRoute>
      }
    />
  </Route>,
];
export const ClientReferencesRouter = [
  <Route
    path="/references"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={References} />
      </ProtectedRoute>
    }
  />,
  <Route path="/reference">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Reference />
        </ProtectedRoute>
      }
    />
  </Route>,
];
